import { CldVideoPlayer } from 'next-cloudinary';
import { useInView } from 'react-intersection-observer';

import { patchedStoryblokEditable } from '../../utils/patchedStoryblokEditable';
import { CarouselVideoItemWrapper } from './CarouselVideoItem.style';
import { CarouselVideoItemProps } from './CarouselVideoItem.types';

import 'next-cloudinary/dist/cld-video-player.css';

export default function CarouselVideoItem(props: CarouselVideoItemProps) {
  const { blok } = props;
  const { cloudinaryUrl, _uid } = blok;
  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '200px 0px' });

  if (!cloudinaryUrl) return null;

  return (
    <CarouselVideoItemWrapper ref={ref} {...patchedStoryblokEditable(blok)}>
      {inView ? (
        <CldVideoPlayer
          id={`carousel-cloudinary-${_uid}`}
          width="310"
          height="435"
          src={cloudinaryUrl}
          preload="metadata"
        />
      ) : null}
    </CarouselVideoItemWrapper>
  );
}
